import { Injectable } from '@angular/core';
import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

type CookieConsentPopup = {
  destroy(): void;
  getStatus(): string;
  hasConsented(): boolean;
};

type CookieConsentApi = {
  initialise(
    config: NgcCookieConsentConfig,
    callback?: (popup: CookieConsentPopup) => void
  ): void;
  status?: string;
};

type CookieConsentWindow = Window & {
  cookieconsent?: CookieConsentApi;
};

@Injectable({
  providedIn: 'root',
})
export class MxCookieConsentService {
  private config?: NgcCookieConsentConfig;
  private popupInstance?: CookieConsentPopup;

  getConfig(): NgcCookieConsentConfig {
    if (!this.config) {
      throw new Error('Cookie consent has not been initialized.');
    }

    return this.config;
  }

  init(config: NgcCookieConsentConfig): void {
    this.config = config;

    const cookieconsent = (window as CookieConsentWindow).cookieconsent;
    if (!cookieconsent) {
      return;
    }

    cookieconsent.initialise(config, (popup) => {
      this.popupInstance = popup;
    });
  }

  destroy(): void {
    this.popupInstance?.destroy();
    this.popupInstance = undefined;
  }

  hasConsented(): boolean {
    if (this.popupInstance) {
      return this.popupInstance.hasConsented();
    }

    const cookieconsent = (window as CookieConsentWindow).cookieconsent;
    const status = this.popupInstance?.getStatus() ?? cookieconsent?.status;

    return status === 'allow' || status === 'dismiss';
  }
}
